// @/data/legalData.ts
export const legalData = {
  lastUpdated: "October 24, 2025",
  companyName: "Your Company Name, Inc.",
  contactEmail: "support@yourdomain.com",

  terms: {
    title: "Terms & Conditions",
    description: "Rules and operational guidelines for accessing our platform.",
    sections: [
      {
        id: 1,
        title: "Acceptance of Terms",
        content:
          "By accessing or using our services provided by {companyName}, you agree to comply with and be legally bound by these Terms & Conditions. These terms govern your access to and use of our platform, products, and services. Please read them carefully before proceeding.",
      },
      {
        id: 2,
        title: "Permitted Use",
        content:
          "You agree not to exploit, duplicate, copy, sell, or resell any portion of the service without explicit written permission from us. Any unauthorized use of our platform constitutes a violation of these terms and may result in immediate termination of your account.",
      },
      {
        id: 3,
        title: "Account Responsibilities",
        content:
          "You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You must immediately notify us of any unauthorized use of your account or any other breach of security.",
      },
      {
        id: 4,
        title: "Intellectual Property",
        content:
          "All content, features, and functionality of our services are owned by {companyName} and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.",
      },
      {
        id: 5,
        title: "Termination",
        content:
          "We reserve the right to terminate or suspend your account and access to our services at our sole discretion, without notice, for conduct that we believe violates these Terms & Conditions or is harmful to other users, us, or third parties.",
      },
    ],
  },

  privacy: {
    title: "Privacy Policy",
    description: "How we handle, safeguard, and process your personal data.",
    sections: [
      {
        id: 1,
        title: "Data Collection",
        content:
          "We collect personal information necessary to deliver, enhance, and secure our services, including account profile details and standard analytical logs. This includes information you provide directly, data collected automatically through your use of our services, and information from third-party sources.",
      },
      {
        id: 2,
        title: "Information Sharing",
        content:
          "We do not sell your personal data. Data is shared only with verified infrastructure providers or as mandated by applicable law. We require all third parties to respect the security of your personal data and to treat it in accordance with the law.",
      },
      {
        id: 3,
        title: "Data Security",
        content:
          "We implement appropriate technical and organizational measures to protect your personal information against accidental or unlawful destruction, loss, alteration, unauthorized disclosure, or access. These measures include encryption, secure servers, and regular security audits.",
      },
      {
        id: 4,
        title: "Cookie Policy",
        content:
          "We use cookies and similar tracking technologies to enhance your experience on our platform. You can control cookie settings through your browser preferences. Essential cookies are required for the platform to function properly and cannot be disabled.",
      },
      {
        id: 5,
        title: "Your Rights",
        content:
          "You have the right to access, correct, or delete your personal information. You may also have the right to restrict or object to certain processing of your data. To exercise these rights, please contact us at the email provided below.",
      },
    ],
  },

  disclosures: {
    title: "Disclosures & Disclaimer",
    description:
      "Mandatory legal notices, disclaimers, and compliance statements.",
    sections: [
      {
        id: 1,
        title: "General Disclosures",
        content:
          "All material published by {companyName} is provided for general informational purposes only and does not constitute formal legal, financial, or technical advice. Users should consult qualified professionals for specific guidance related to their individual circumstances.",
      },
      {
        id: 2,
        title: "Limitation of Liability",
        content:
          "We make no warranties, express or implied, regarding system uptime, uninterrupted availability, or absolute accuracy of third-party content integrations. To the maximum extent permitted by law, we disclaim all warranties and liability for damages arising from your use of our services.",
      },
      {
        id: 3,
        title: "Regulatory Compliance",
        content:
          "Our services are designed to comply with applicable laws and regulations. However, we make no representation that materials on our platform are appropriate or available for use in all jurisdictions. Users are responsible for compliance with local laws.",
      },
      {
        id: 4,
        title: "Third-Party Links",
        content:
          "Our platform may contain links to third-party websites or services. These links are provided for convenience only, and we have no control over the content, privacy policies, or practices of any third-party sites. We disclaim all responsibility for third-party content.",
      },
      {
        id: 5,
        title: "Changes to Disclosures",
        content:
          "We reserve the right to modify these disclosures at any time. Changes will be effective immediately upon posting to our platform. Your continued use of our services following the posting of changes constitutes your acceptance of such changes.",
      },
    ],
  },
};